// extracted by mini-css-extract-plugin
export default {"card":"_403_card__eiPzq","body":"_403_body__zUEx1","container":"_403_container__TNiyb","status":"_403_status__1a0vx","message":"_403_message__H-3yd"};